import React, { Component } from "react";
import PropTypes from "prop-types";
import throttle from "LIB/throttle";
import { SearchPropTypes } from "MODULES/shared/components";

export default class SearchFilter extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    initialFilter: PropTypes.string,
    submitOnSingleResult: PropTypes.func,
    onValueChange: PropTypes.func,
    ...SearchPropTypes
  };

  static defaultProps = {
    placeholder: ""
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.initialFilter || "" // Initialize the state with the initialFilter prop or an empty string
    };
    this.onChange = throttle(props.onSubmit, 300);
  }

  handleChange = e => {
    const { value } = e.target;
    this.onChange(e.target.value);
    this.setState({ value }, () => {
      // This callback function is executed after the state is updated
      if (this.props.onValueChange) {
        this.props.onValueChange(value); // Inform parent component of the new input value
      }
    });
    this.props.onSubmit(value);
  };

  handleSubmit = e => {
    const { submitOnSingleResult, results } = this.props;

    if (submitOnSingleResult && results.length === 1 && e.keyCode === 13) {
      submitOnSingleResult(results[0]);
    }
  };

  render() {
    const { initialFilter, placeholder } = this.props;

    return (
      <input
        autoFocus
        className="form-control input-lg"
        type="search"
        onKeyUp={this.handleSubmit}
        onChange={this.handleChange}
        defaultValue={initialFilter}
        placeholder={placeholder}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/SearchFilter/SearchFilter.jsx